export namespace Constants {
  export const BIKE_NAME_REGEX: RegExp = /^[A-Za-z0-9ÄäÖöÜü ]{1,128}$/;

  export const RECOVERY_SERVICE_ADDON_IDS: string[] = ['AB0-R-0365', 'AB0-R-030'];

  export const IMAGE_ID_ADD_BIKE: string = 'add-bike-image';
}
